export default __webpack_public_path__ + "static/media/learning.810b6940.svg";